import HiggsPromise from '../utils/higgsPromise';
import { HttpMethod } from '../constants/enum';

// 获取用户信息
export function getUserInfo() {
    return HiggsPromise({
        url: '/user/getUser'
    });
}

/* ---------------- 监管日志 ---------------- */
// 列表
export function getLogList(data) {
    return HiggsPromise({
        url: '/user/supervision/log/list',
        data: data
    });
}

// 详情列表
export function getLogDetailList(data) {
    return HiggsPromise({
        url: '/user/supervision/log/detail/list',
        data: data
    });
}

// 添加
export function addLog(data) {
    return HiggsPromise({
        url: '/user/supervision/log/add',
        type: HttpMethod.POST,
        data: data
    });
}

// 删除
export function delLog(data) {
    return HiggsPromise({
        url: '/user/supervision/log/delete',
        type: HttpMethod.POST,
        data: data
    });
}

/* ---------------- 个人收藏 ---------------- */
// 列表
export function getCollectList(data) {
    return HiggsPromise({
        url: '/user/collect/list',
        data: data
    });
}
// 取消收藏
export function cancelCollect(data) {
    return HiggsPromise({
        url: '/user/collect/cancel',
        type: HttpMethod.POST,
        data: data
    });
}

/* ---------------- 历史报告 ---------------- */
// 历史报告
export function getHistoryReport(data) {
    return HiggsPromise({
        url: '/user/report/history',
        data: data
    });
}
// 修改密码
export function updatePwd(data) {
    return HiggsPromise({
        url: '/user/password/update',
        type: HttpMethod.POST,
        data: data
    });
}

/* ---------------- 管理员 ---------------- */
// 用户列表
export function getUserList(data) {
    return HiggsPromise({
        url: '/user/admin/list',
        data: data
    });
}
// 添加用户
export function addUser(data) {
    return HiggsPromise({
        url: '/user/add',
        type: HttpMethod.POST,
        data: data
    });
}
// 启用用户
export function enableUser(data) {
    return HiggsPromise({
        url: '/user/opertion/enable',
        type: HttpMethod.POST,
        data: data
    });
}
// 禁用用户
export function disableUser(data) {
    return HiggsPromise({
        url: '/user/opertion/disable',
        type: HttpMethod.POST,
        data: data
    });
}
// 重置密码
export function resetUserPwd(data) {
    return HiggsPromise({
        url: '/user/opertion/reset',
        type: HttpMethod.POST,
        data: data
    });
}
// 验证用户名
export function getNameExist(data) {
    return HiggsPromise({
        url: '/user/name/exist',
        data: data
    });
}
// 验证邮箱
export function getEmailExist(data) {
    return HiggsPromise({
        url: '/user/email/exist',
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/services/user.js